export default "__VITE_ASSET__D6OrCx7C__"